import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { reviews } from '../data/testimonials';
export function Testimonials() {
  return <section className="border-y border-electric/30 bg-industrial py-16 sm:py-20" aria-labelledby="reviews-title" data-id="element-190" data-mp="3fycqdmmec5as">
      <div className="mx-auto max-w-6xl px-4" data-id="element-191" data-mp="3b01el6cjjkpx">
        <SectionHeading id="reviews-title" data-id="element-192" data-mp="36ypl2pqjqfcg">Testimonials from <span className="text-gold" data-id="element-193" data-mp="370ajiqfzeifl">Mechanical Engineering Professionals</span></SectionHeading>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-194" data-mp="31ybhbjvz9rk8">
          {reviews.map(([initials, name, role, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-2xl border border-electric/40 bg-navy p-6 shadow-glow" data-id="element-195" data-mp="2x2w32qu25tna" data-mpi={index}>
              <div className="flex text-gold" aria-label="5 out of 5 stars" data-id="element-196" data-mp="m5kkcjovulab">
                {Array.from({
              length: 5
            }, (_, star) => <StarIcon key={star} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-197" data-mp="79bpduc0yu3p" />)}
              </div>
              <blockquote className="mt-4 flex-1 leading-relaxed text-steel" data-id="element-198" data-mp="c73nj639jcgc">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-electric/20 pt-4" data-id="element-199" data-mp="zx7qrccjha6t">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-electric/60 bg-industrial font-display text-sm font-extrabold text-silver" data-id="element-200" data-mp="14ur5edd5foza">
                  {initials}
                </span>
                <span data-id="element-201" data-mp="1ivk4lbeeb88q">
                  <b className="block text-sm text-silver" data-id="element-202" data-mp="1iv223x153xsd">{name}</b>
                  <small className="text-xs text-steel" data-id="element-203" data-mp="1nm0kd25ov5y9">{role}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}